import { Component, model, OnInit } from "@angular/core";
import { ToastService } from "../../../services/toast.service";
import { NgxSpinnerService } from "ngx-spinner";
import Tokenizer from "fluidpay-tokenizer";
import { environment } from "../../../../environments/environment";
import { CartService } from "../../../services/cart.service";
import { CartDto } from "../../../dtos/CartDto";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { NgbDate, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { StateDto } from "../../../dtos/StateDto";
import { Router } from "@angular/router";

@Component({
  selector: 'app-checkout',
  standalone: false,
  templateUrl: './app-checkout.component.html',
  styleUrl: './app-checkout.component.scss',
  host: {
    class: 'row flex-grow-1'
  }
})
export class CheckoutComponent implements OnInit {

    constructor(
        private toastService: ToastService,
        private spinner: NgxSpinnerService,
        private cartService: CartService,
        private router: Router,
    ) {
        const cartId = localStorage.getItem('cartId');
        if(cartId) {
          this.cartService.getCart(cartId).subscribe((value: any) => { 
            this.cart = value;
          });
        }
    }
    today = new Date();
    // TODO: move these to env
    cardDisabled = false;
    selectedStateCode = '';
    selectedShippingStateCode = '';
    cardForm = new FormGroup({
        firstName: new FormControl('', Validators.required),
        lastName: new FormControl('', Validators.required),
        dateOfBirth: new FormControl(new NgbDate(1, 1, 1969), Validators.required),
        addressLine1: new FormControl('', Validators.required),
        addressLine2: new FormControl(''),
        city: new FormControl('', Validators.required),
        state: new FormControl('', Validators.required),
        zip: new FormControl('', Validators.required),
        email: new FormControl('', Validators.required),
        phoneNumber: new FormControl('', Validators.required),
        shippingAddressLine1: new FormControl('', Validators.required),
        shippingAddressLine2: new FormControl(''),
        shippingCity: new FormControl('', Validators.required),
        shippingState: new FormControl('', Validators.required),
        shippingZip: new FormControl('', Validators.required),
    });
  
    maxDate: NgbDateStruct = { year: this.today.getFullYear()-21, month: this.today.getMonth()+1, day: this.today.getDate() }
    minDate: NgbDateStruct = { year: this.today.getFullYear()-121, month: this.today.getMonth()+1, day: this.today.getDate() }

    tokenizer: Tokenizer;
    states: StateDto[] = [
    {
      "name": "Alabama",
      "code": "AL"
    },
    {
      "name": "Alaska",
      "code": "AK"
    },
    {
      "name": "Arizona",
      "code": "AZ"
    },
    {
      "name": "Arkansas",
      "code": "AR"
    },
    {
      "name": "California",
      "code": "CA"
    },
    {
      "name": "Colorado",
      "code": "CO"
    },
    {
      "name": "Connecticut",
      "code": "CT"
    },
    {
      "name": "Delaware",
      "code": "DE"
    },
    {
      "name": "Florida",
      "code": "FL"
    },
    {
      "name": "Georgia",
      "code": "GA"
    },
    {
      "name": "Hawaii",
      "code": "HI"
    },
    {
      "name": "Idaho",
      "code": "ID"
    },
    {
      "name": "Illinois",
      "code": "IL"
    },
    {
      "name": "Indiana",
      "code": "IN"
    },
    {
      "name": "Iowa",
      "code": "IA"
    },
    {
      "name": "Kansas",
      "code": "KS"
    },
    {
      "name": "Kentucky",
      "code": "KY"
    },
    {
      "name": "Louisiana",
      "code": "LA"
    },
    {
      "name": "Maine",
      "code": "ME"
    },
    {
      "name": "Maryland",
      "code": "MD"
    },
    {
      "name": "Massachusetts",
      "code": "MA"
    },
    {
      "name": "Michigan",
      "code": "MI"
    },
    {
      "name": "Minnesota",
      "code": "MN"
    },
    {
      "name": "Mississippi",
      "code": "MS"
    },
    {
      "name": "Missouri",
      "code": "MO"
    },
    {
      "name": "Montana",
      "code": "MT"
    },
    {
      "name": "Nebraska",
      "code": "NE"
    },
    {
      "name": "Nevada",
      "code": "NV"
    },
    {
      "name": "New Hampshire",
      "code": "NH"
    },
    {
      "name": "New Jersey",
      "code": "NJ"
    },
    {
      "name": "New Mexico",
      "code": "NM"
    },
    {
      "name": "New York",
      "code": "NY"
    },
    {
      "name": "North Carolina",
      "code": "NC"
    },
    {
      "name": "North Dakota",
      "code": "ND"
    },
    {
      "name": "Ohio",
      "code": "OH"
    },
    {
      "name": "Oklahoma",
      "code": "OK"
    },
    {
      "name": "Oregon",
      "code": "OR"
    },
    {
      "name": "Pennsylvania",
      "code": "PA"
    },
    {
      "name": "Rhode Island",
      "code": "RI"
    },
    {
      "name": "South Carolina",
      "code": "SC"
    },
    {
      "name": "South Dakota",
      "code": "SD"
    },
    {
      "name": "Tennessee",
      "code": "TN"
    },
    {
      "name": "Texas",
      "code": "TX"
    },
    {
      "name": "Utah",
      "code": "UT"
    },
    {
      "name": "Vermont",
      "code": "VT"
    },
    {
      "name": "Virginia",
      "code": "VA"
    },
    {
      "name": "Washington",
      "code": "WA"
    },
    {
      "name": "West Virginia",
      "code": "WV"
    },
    {
      "name": "Wisconsin",
      "code": "WI"
    },
    {
      "name": "Wyoming",
      "code": "WY"
    }
    ]    
    cart: CartDto = new CartDto();
    estimatedShipping: number;

    async createPayment(tokenizerResp: any) {
      const body = JSON.stringify({
        sourceId: tokenizerResp.token,
        idempotencyKey: window.crypto.randomUUID(),
        billingContact: {
          givenName : this.cardForm.get('firstName')?.value,
          familyName : this.cardForm.get('lastName')?.value,
          email : this.cardForm.get('email')?.value,
          phone : this.cardForm.get('phoneNumber')?.value,
          address : this.cardForm.get('addressLine1')?.value,
          city : this.cardForm.get('city')?.value,
          state : this.selectedStateCode,
          zip : this.cardForm.get('zip')?.value,
        },
        shippingInfo: {
          address : this.cardForm.get('shippingAddressLine1')?.value,
          city : this.cardForm.get('shippingCity')?.value,
          state : this.selectedShippingStateCode,
          zip : this.cardForm.get('shippingZip')?.value,
        },
        cartId: this.cart.id
      });

      this.spinner.show();

      await fetch(`${environment.apiUrl}/orders/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body,
      }).then(async data => {
        if (data.ok) {
          this.showSuccessToast();
          this.cardForm.reset();
          await this.deleteCart();
        } else {
          // parse the error message from the response
          const errorMsg = (await data.json()).message;
          this.showFailureToast(errorMsg);
        }
      });

      this.spinner.hide();
  }

    showSuccessToast() {
        this.toastService.show('Check your email inbox for confirmation.', { header: 'Registration Succeeded', classname: 'bg-success text-light' });
    }

    async deleteCart() {
      await fetch(`${environment.apiUrl}/carts/deleteCart/${this.cart.id}`, {
        method: 'DELETE',
      }).then(data => {
        if(data.ok) {
          localStorage.removeItem('cartId');
          this.router.navigate(['/confirmation']);
        }
      })
    }

    // overloaded methods
    showFailureToast(): void;
    showFailureToast(message: string): void;
    
    showFailureToast(message?: string): void {
      if(message)
        this.toastService.show(message, { header: 'Failed to Purchase Cart', classname: 'bg-danger text-light' });      
      else
        this.toastService.show('Please message us for support.', { header: 'Failed to Add Product', classname: 'bg-danger text-light' });
    }

    selectState(selectedState: StateDto) {
        this.selectedStateCode = selectedState.code;
        this.cardForm.get('state')?.setValue(selectedState.name);
    }
    selectShippingState(selectedState: StateDto) {
      this.selectedShippingStateCode = selectedState.code;
      this.cardForm.get('shippingState')?.setValue(selectedState.name);
    }
    async onZipChange() {
      if(this.cardForm.get('shippingZip')?.value?.length == 5) {
        const body = JSON.stringify({
          cartId: this.cart.id,
          deliveryZip: this.cardForm.get('shippingZip')?.value
        });
        await fetch(`${environment.apiUrl}/orders/estimated-shipping`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body,
        }).then(data => {
          return data.json();
        }).then(responseJson => {
          this.estimatedShipping = responseJson;
        });
      }
    }

  async ngOnInit() {
    this.tokenizer = new Tokenizer({
      // Your public API key (from Control Panel → Settings → API Keys)
      apikey: environment.fluidPayKey,
      url: environment.fluidPayUrl,

      // CSS selector where the iframe will be injected
      container: '#checkout-form',

      settings: {
        payment: {
          types: ['card'],  // Enable both card and ACH
          card: {
            requireCVV: true,
          }
        }
      },

      // Callback when tokenizer.submit() completes
      submission: (resp) => {

        // Token generated successfully
        if (resp.status === 'success') {
          this.createPayment(resp)
        }

        // Form validation failed (empty or invalid fields)
        else if (resp.status === 'validation') {
          console.log('Invalid fields:', resp.invalid)
        }

        // Error occurred (network, invalid API key, etc.)
        else {
          console.log('Error:', resp.msg)
        }
      }
    });
  }

  // Get Cart Subtotal + Estimated Shipping
  getTotal() {
    if(isNaN(this.estimatedShipping))
      return (this.cart.subtotal / 100);
    else
      return (this.estimatedShipping + (this.cart.subtotal / 100)).toFixed(2);
  }
}
